export default __webpack_public_path__ + "static/media/jayanti.983a4b69.jpg";